import { render, staticRenderFns } from "./edit-department.vue?vue&type=template&id=4fe47a5a&scoped=true&"
import script from "./edit-department.vue?vue&type=script&lang=js&"
export * from "./edit-department.vue?vue&type=script&lang=js&"
import style0 from "./edit-department.vue?vue&type=style&index=0&id=4fe47a5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe47a5a",
  null
  
)

export default component.exports